import { pipe } from 'rxjs';
import { selectGame } from '../../../selectors';
import { prop } from 'ramda';

export const selectTravelsState = pipe(selectGame, prop('travels'));

export const selectTravel = (travelId: string) =>
  pipe(selectTravelsState, (travels) => travels[travelId]);
